import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/guides/")({
  beforeLoad: () => {
    throw redirect({ to: "/guias/pequenas-bolinhas-no-penis", statusCode: 301 });
  },
});